import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { AssetModalPanelContainer } from "~/components/AssetModal/Panel/Content/Container";
import { CommentsFilterBar } from "~/components/PrivateAssetModal/PrivateCommentsPanel/components/CommentsFilterBar";
import { CommentsVersionsDropdown } from "~/components/PrivateAssetModal/PrivateCommentsPanel/components/CommentsVersionsDropdown";
import { PublicComments } from "~/components/PublicAssetModal/components/PublicCommentsPanel";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { canSeeAssetVersions, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicAssetCommentsPanelContainer = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const canViewAssetVersions = canSeeAssetVersions(permissions);
    const canDiscuss = canViewAssetDiscussions(permissions);
    const panel = useMemo(()=>/*#__PURE__*/ _jsx(PublicComments, {}), []);
    const contentHeader = useMemo(()=>canDiscuss && canViewAssetVersions ? /*#__PURE__*/ _jsx(CommentsFilterBar, {
            children: /*#__PURE__*/ _jsx(CommentsVersionsDropdown, {})
        }) : undefined, [
        canDiscuss,
        canViewAssetVersions
    ]);
    return /*#__PURE__*/ _jsx(AssetModalPanelContainer, {
        title: "COMMENTS",
        contentHeader: contentHeader,
        panel: panel
    });
});
PublicAssetCommentsPanelContainer.displayName = "PublicAssetCommentsPanelContainer";
